"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useViewList = useViewList;
const swr_1 = __importDefault(require("swr"));
const utils_1 = require("../utils");
const useViewClient_1 = require("./useViewClient");
/**
 * Calls `view.list` and returns an SWR response. SWR middleware `laggy` is used to make flipping
 * between pages look better, this is done by keeping previously loaded data while new data is loading.
 * SWR `revalidateOnFocus` option is set to `false`.
 *
 * @param view - view name
 * @param request - request to pass to `viewClient.list`, this is optional, if not set backend will not be called and result will not be returned
 * @param baseUrl - optional base URL
 * @param tokenProvider - optional token provider
 * @param config - custom SWR configuration object, can be used to remove the custom `laggy` middleware
 */
function useViewList(view, request, baseUrl, tokenProvider, config) {
    const viewClient = (0, useViewClient_1.useViewClient)(view, baseUrl, tokenProvider);
    return (0, swr_1.default)(request ? [`/platform/view/${view}/list`, request] : null, async ([, request]) => {
        return request ? viewClient.list(request) : undefined;
    }, config ?? {
        use: [utils_1.laggy],
        revalidateOnFocus: false,
    });
}
